"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Cross = function Cross(props) {
  return _react.default.createElement("svg", {
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, _react.default.createElement("title", null, props.altText), _react.default.createElement("path", {
    d: "M17.7083 18.2291C17.6399 18.2292 17.5722 18.2158 17.509 18.1896C17.4458 18.1634 17.3884 18.125 17.3401 18.0765L6.9234 7.65988C6.82572 7.5622 6.77085 7.42972 6.77085 7.29159C6.77085 7.15345 6.82572 7.02098 6.9234 6.9233C7.02108 6.82563 7.15355 6.77075 7.29169 6.77075C7.42982 6.77075 7.5623 6.82563 7.65997 6.9233L18.0766 17.34C18.1495 17.4128 18.1991 17.5056 18.2192 17.6067C18.2393 17.7077 18.229 17.8124 18.1896 17.9076C18.1501 18.0028 18.0834 18.0841 17.9977 18.1414C17.9121 18.1986 17.8113 18.2291 17.7083 18.2291Z",
    fill: props.foregroundColor
  }), _react.default.createElement("path", {
    d: "M7.2917 18.2291C7.36011 18.2292 7.42786 18.2158 7.49106 18.1896C7.55426 18.1634 7.61166 18.125 7.65996 18.0765L18.0766 7.65988C18.125 7.61151 18.1634 7.55409 18.1895 7.4909C18.2157 7.42771 18.2292 7.35999 18.2292 7.29159C18.2292 7.22319 18.2157 7.15546 18.1895 7.09227C18.1634 7.02908 18.125 6.97167 18.0766 6.9233C18.0283 6.87494 17.9708 6.83657 17.9077 6.8104C17.8445 6.78422 17.7767 6.77075 17.7083 6.77075C17.6399 6.77075 17.5722 6.78422 17.509 6.8104C17.4458 6.83657 17.3884 6.87494 17.3401 6.9233L6.92339 17.34C6.85053 17.4128 6.80092 17.5056 6.78082 17.6067C6.76072 17.7077 6.77103 17.8124 6.81046 17.9076C6.84988 18.0028 6.91665 18.0841 7.00231 18.1414C7.08797 18.1986 7.18868 18.2291 7.2917 18.2291Z",
    fill: props.foregroundColor
  }));
};

Cross.defaultProps = {
  altText: "Cross",
  foregroundColor: "#2D5AB4"
};
Cross.propTypes = {
  altText: _propTypes.default.string,
  foregroundColor: _propTypes.default.string
};
var _default = Cross;
exports.default = _default;